import { IceAgent, RandomUfrag } from "./webrtc";
export function DiscoverLocalInfo(configuration) {
    return new Promise((resolve, reject) => {
        let localInfo = { cands: [], ifs: [] };
        let ipDiscoveryAgent = new IceAgent();
        ipDiscoveryAgent.dummyClient(RandomUfrag(), (ev) => {
            if (!ev || !ev.candidate) {
                return;
            }
            console.log(ev.candidate);
            localInfo.cands = [...localInfo.cands, ev.candidate];
        }, configuration).then(() => {
            localInfo.ifs = [];
            for (let i in localInfo.cands) {
                let c = localInfo.cands[i];
                if (!c.protocol || !c.protocol.startsWith("udp")) {
                    continue;
                }
                if (c.type == "srflx") {
                    if (c.address == null) {
                        continue;
                    }
                    let entry = { addr: c.address, randomPorts: true, cand: c };
                    for (let j in localInfo.cands) {
                        let hc = localInfo.cands[j];
                        if (hc.type == "host" && hc.port == c.port) {
                            entry.randomPorts = false;
                            entry.relatedHostCandidate = hc;
                            break;
                        }
                    }
                    localInfo.ifs = [...localInfo.ifs, entry];
                }
            }
            resolve(localInfo);
        });
    });
}
